import {RumTimeMark, sendRumTimeMark} from '@yandex-delivery/modules/rum'
import {applyPolyfills} from '@yandex-delivery/polyfills'
import React, {StrictMode} from 'react'
import ReactDOM from 'react-dom'

import {ensureMockSharingKey} from './api/mock-mode'
import {App} from './app'

window.addEventListener('error', event => {
  console.error('[GLOBAL ERROR]', event.error || event.message)
})

window.addEventListener('unhandledrejection', event => {
  console.error('[UNHANDLED PROMISE REJECTION]', event.reason)
})

sendRumTimeMark(RumTimeMark.BEFORE_JS_FRAMEWORK_INIT)

applyPolyfills()
  .then(() => {
    ensureMockSharingKey()
    ReactDOM.render(
      <StrictMode>
        <App />
      </StrictMode>,
      document.getElementById('root'),
      () => {
        sendRumTimeMark(RumTimeMark.REACT_INITED)
      },
    )
  })
  .catch(err => {
    console.error('[index.tsx] Failed to apply polyfills:', err)
  })

sendRumTimeMark(RumTimeMark.JS_FRAMEWORK_INITED)
